import { Button, Form, Input, message, Modal, Select } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { PureQueryOptions } from 'apollo-client';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import { validatePhoneFormat } from 'smartpi-core';
import { client } from 'src/services/api';

interface RedeemableSku {
  id: number;
  start: string;
}

const GET_REDEEMABLE_SKUS_QUERY = gql`
  query getRedeemableSkus($mobile: String!, $code: String!) {
    redeemableSkus(mobile: $mobile, code: $code) {
      id
      start
    }
  }
`;

const EXCHANGE_REDEEM_CODE_MUTATION = gql`
  mutation exchangeRedeemCodeMutation($mobile: String!, $code: String!, $skuId: Int!) {
    redeemRedeemCode(mobile: $mobile, code: $code, skuId: $skuId) {
      id
    }
  }
`;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

interface Props {
  redeemCode: string;
  refetchQueries: PureQueryOptions[];
  form: WrappedFormUtils;
}
interface State {
  isExchangeRedeemCodePopupConfirmVisible: boolean;
  mobile: string;
  skuId?: number;
  optionalSkus: RedeemableSku[];
  isShowSelectSkuState: boolean;
}

export class ExchangeRedeemCode extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isExchangeRedeemCodePopupConfirmVisible: false,
      mobile: '',
      optionalSkus: [],
      isShowSelectSkuState: false,
    };
  }

  exchangeRedeemCodeConfirm = () => {
    this.setState({ isExchangeRedeemCodePopupConfirmVisible: true });
  };

  getOptionalSkus = async (mobile: string) => {
    try {
      const result = await client.query<{ redeemableSkus: RedeemableSku[] }>({
        query: GET_REDEEMABLE_SKUS_QUERY,
        variables: { mobile, code: this.props.redeemCode },
      });

      const { redeemableSkus = [] } = result.data;
      return redeemableSkus;
    } catch (error) {
      message.error(`${error.message}`);
      return;
    }
  };

  render() {
    const { skuId, mobile, optionalSkus, isShowSelectSkuState } = this.state;
    const { redeemCode } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Button size="small" style={{ marginTop: 10 }} type="primary" onClick={() => this.exchangeRedeemCodeConfirm()}>
          帮助兑换
        </Button>
        <Mutation
          mutation={EXCHANGE_REDEEM_CODE_MUTATION}
          variables={{
            skuId,
            mobile,
            code: redeemCode,
          }}
          refetchQueries={this.props.refetchQueries}
        >
          {(exchangeRedeemCodeMutation, { loading }) => {
            return (
              <Modal
                title="帮助用户兑换兑换码"
                okText={isShowSelectSkuState ? '确定' : '下一步'}
                confirmLoading={loading}
                visible={this.state.isExchangeRedeemCodePopupConfirmVisible}
                onOk={async () => {
                  this.props.form.validateFields(async (err, values) => {
                    if (err) {
                      message.error(err);
                      return;
                    }
                    if (!validatePhoneFormat(values.mobile) && !isShowSelectSkuState) {
                      message.error('请输入合法的手机号!');
                      return;
                    }
                    if (!isShowSelectSkuState) {
                      const skus = await this.getOptionalSkus(values.mobile);

                      if (!skus || (skus && skus.length === 0)) {
                        message.error(`无可选sku，暂不支持兑换`);
                        return;
                      }

                      if (skus) {
                        this.setState({ isShowSelectSkuState: true, optionalSkus: skus, mobile: values.mobile });
                        return;
                      }
                      return;
                    }

                    if (!values.skuId) {
                      message.error('请选择开课时间');
                      return;
                    }
                    this.setState({ skuId: values.skuId }, async () => {
                      try {
                        await exchangeRedeemCodeMutation();
                        this.setState({ isExchangeRedeemCodePopupConfirmVisible: false });
                        message.success('兑换成功！');
                      } catch (error) {
                        message.error(`${error.message}`);
                      }
                    });
                  });
                }}
                onCancel={() => {
                  this.setState({
                    isExchangeRedeemCodePopupConfirmVisible: false,
                    skuId: undefined,
                    isShowSelectSkuState: false,
                    optionalSkus: [],
                  });
                }}
              >
                <Form>
                  {!isShowSelectSkuState ? (
                    <Form.Item label="手机号" {...formItemLayout}>
                      {getFieldDecorator('mobile')(<Input placeholder="请输入手机号" />)}
                    </Form.Item>
                  ) : (
                    <Form.Item {...formItemLayout} label="选择开课时间">
                      {getFieldDecorator('skuId')(
                        <Select style={{ width: '100%' }} placeholder="请选择开课时间">
                          {optionalSkus.map(item => {
                            return (
                              <Select.Option key={item.id} value={item.id}>{`${moment(item.start)
                                .utcOffset(8)
                                .format('MM.DD')}开课`}</Select.Option>
                            );
                          })}
                        </Select>,
                      )}
                    </Form.Item>
                  )}
                </Form>
              </Modal>
            );
          }}
        </Mutation>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/redeemCode/ExchangeRedeemCode.tsx